// import React from "react";
import './Home.css';
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import React, { useState, useRef, useEffect, useCallback } from "react";


import ourmem from "./HomeImages/Ourmembers.png";
import exp from "./HomeImages/exp.png";
import happyclient from "./HomeImages/happyclient.png";
import projects from "./HomeImages/projects.png";
import siccap from "./HomeImages/science-capcule.png";
import RnD from "./HomeImages/sciencebox1.png";

import sicarrow from "./HomeImages/sic_arrow.png";
import siencebox2 from "./HomeImages/sciencebox2.png";
import siencebox3 from "./HomeImages/sciencebox3.png";

import team1 from "./HomeImages/team1.png";
import team2 from "./HomeImages/team2.png";
import team3 from "./HomeImages/team3.png";

import service1 from "./HomeImages/service1.png";
import service2 from "./HomeImages/service2.png";
import service3 from "./HomeImages/service3.png";
import service4 from "./HomeImages/service4.png";
import service5 from "./HomeImages/service5.png";
import service6 from "./HomeImages/service6.png";

import Marquee from "react-fast-marquee";

import Partner1 from '../Services/ServicesImages/cipla.png';
import Partner2 from '../Services/ServicesImages/neuland.png';
import Partner3 from '../Services/ServicesImages/mylan.png';
import Partner4 from '../Services/ServicesImages/natco.png';

import whychoose from './HomeImages/whychooseus.png';
import whychoose2 from './HomeImages/whychooseus2.png';
import whychoose3 from './HomeImages/whychoose3.png';
import whychoose4 from './HomeImages/whychoose4.png';

import banner1 from './HomeImages/1.png';
import banner2 from './HomeImages/2.png';
import banner3 from './HomeImages/3.png';
import banner4 from './HomeImages/4.png';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { useNavigate } from "react-router-dom";


function Home() {
        const navigate = useNavigate();
        const [active, setActive] = useState(1); // Index of the active slide
        const [other1, setOther1] = useState(null); // Index of the previous slide
        const [other2, setOther2] = useState(null); // Index of the next slide
        const carouselRef = useRef(null); // Reference to the carousel DOM element
        const autoPlayRef = useRef(null); // Reference for autoplay interval

        const items = [
            {
                title: "Innovating Healthcare for a Better World",
                description:
                    "Harnessing science and technology to improve lives through advanced pharmaceutical solutions.",
                image: banner1,
                style: {
                    backgroundImage: "linear-gradient(to right bottom, #62b6db, #8bc8e3, #afd9eb, #d3ebf4, #f6fcfe)",
                },
            },
            {
                title: "Leading API Development Excellence",
                description:
                    "From concept to creation, we specialize in developing high-quality Active Pharmaceutical Ingredients (APIs) for global markets.",
                image: banner2,
                style: {
                    background: "linear-gradient(90deg, rgba(218,218,218,1) 29%, rgba(22,157,126,1) 100%)",
                },
            },
            {
                title: "Advancing Innovations in Nutrition Development",
                description:
                    "We pioneer advanced nutritional solutions that promote health and wellness, redefining standards with cutting-edge research and sustainable practices.",
                image: banner3,
                style: {
                    background: "linear-gradient(90deg, rgba(251,250,197,1) 29%, rgba(242,204,78,1) 100%)",
                },
            },
            {
                title: "Innovating Drug Delivery Systems",
                description:
                    "Our advanced drug delivery technologies enhance patient outcomes and ensure precision in pharmaceutical applications.",
                image: banner4,
                style: {
                    background: "linear-gradient(293deg, rgba(121,207,254,1) 29%, rgba(246,252,254,1) 100%)",
                },
            },
        ];

        const countItem = items.length; // Total number of slides

         // Function to calculate indices of neighboring slides
    const calculateIndices = useCallback(
        (index) => {
            setOther1(index - 1 < 0 ? countItem - 1 : index - 1);
            setOther2(index + 1 >= countItem ? 0 : index + 1);
        },
        [countItem]
    );

    // AutoPlay Logic
    const resetAutoPlay = useCallback(() => {
        clearInterval(autoPlayRef.current);
        autoPlayRef.current = setInterval(() => {
            setActive((prevActive) => {
                const newIndex = prevActive + 1 >= countItem ? 0 : prevActive + 1;
                calculateIndices(newIndex);
                return newIndex;
            });
        }, 5000);
    }, [countItem, calculateIndices]);

    // Next Slide Function
    const nextSlide = useCallback(() => {
        if (carouselRef.current) {
            carouselRef.current.classList.remove("prev");
            carouselRef.current.classList.add("next");
        }
        const newIndex = active + 1 >= countItem ? 0 : active + 1;
        setActive(newIndex);
        calculateIndices(newIndex);
        resetAutoPlay();
    }, [active, countItem, calculateIndices, resetAutoPlay]);

    // Previous Slide Function
    const prevSlide = useCallback(() => {
        if (carouselRef.current) {
            carouselRef.current.classList.remove("next");
            carouselRef.current.classList.add("prev");
        }
        const newIndex = active - 1 < 0 ? countItem - 1 : active - 1;
        setActive(newIndex);
        calculateIndices(newIndex);
        resetAutoPlay();
    }, [active, countItem, calculateIndices, resetAutoPlay]);

    // Initialize Indices and AutoPlay on Mount
    useEffect(() => {
        calculateIndices(active);

        // Start autoplay
        autoPlayRef.current = setInterval(() => {
            setActive((prevActive) => {
                const newIndex = prevActive + 1 >= countItem ? 0 : prevActive + 1;
                calculateIndices(newIndex);
                return newIndex;
            });
        }, 5000);

        // Cleanup on unmount
        return () => clearInterval(autoPlayRef.current);
    }, [active, calculateIndices, countItem]);
        
        
        return (
            <>

                <div className="home-container">
                    <Navbar />


                    <main>
                        <section className="home_carousel" ref={carouselRef}>
                            <div className="home_list">
                                {items.map((item, index) => {
                                    // Determine the class based on the active, other_1, and other_2 indices
                                    const className =
                                        index === active
                                            ? 'home_item active'
                                            : index === other1
                                                ? 'home_item other_1'
                                                : index === other2
                                                    ? 'home_item other_2'
                                                    : 'home_item';

                                    return (
                                        <article key={index} className={className}>
                                            <div className="home_main-content" style={item.style}>
                                                <div className="home_content">
                                                    <h2>{item.title}</h2>
                                                    <p className="home_description">{item.description}</p>
                                                    <button className="home_addToCard"  onClick={()=>navigate('/services')}>Explore More</button>
                                                </div>
                                            </div>
                                            <figure className="home_image">
                                                <img
                                                    src={item.image}
                                                    alt={`Slide ${index + 1}`}
                                                    onAnimationStart={(e) => (e.target.style.animation = 'none')}
                                                />
                                            </figure>
                                        </article>
                                    );
                                })}
                            </div>
                            <div className="home_arrows">
                                <button id="prev" onClick={prevSlide}>
                                    <ChevronLeftIcon />
                                </button>
                                <button id="next" onClick={nextSlide}>
                                    <ChevronRightIcon />
                                </button>
                            </div>
                        </section>
                    </main>

                    <div className="home-count-section">
                        <div className="home-count-total">
                            <div className="home-count-set">
                                <div className="home-count-img">
                                    <img src={ourmem} alt="our members" />
                                </div>
                                <div className="home-count">
                                    <h2>12+</h2>
                                    <p>Our Members</p>
                                </div>
                            </div>
                            <div className="home-count-set">
                                <div className="home-count-img">
                                    <img src={happyclient} alt="our members" />
                                </div>
                                <div className="home-count">
                                    <h2>600+</h2>
                                    <p>Happy Clients</p>
                                </div>
                            </div>
                            <div className="home-count-set">
                                <div className="home-count-img">
                                    <img src={exp} alt="our members" />
                                </div>
                                <div className="home-count">
                                    <h2>10+</h2>
                                    <p>Years Experience</p>
                                </div>
                            </div>
                            <div className="home-count-set">
                                <div className="home-count-img">
                                    <img src={projects} alt="our members" />
                                </div>
                                <div className="home-count">
                                    <h2>30+</h2>
                                    <p>Projects Done</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="home-whyChooseUs-con">
                        <div className="home-whyChooseUs">


                            <div className="home-whyChooseUs-content">
                                <h1>Why Choose Us ?</h1>
                                <p>We’re dedicated to pushing the boundaries of pharmaceutical science. Our research teams work at the cutting edge, using the latest technologies to develop groundbreaking treatments.</p>

                                <div className="home-whyChooseUs-subcontent">
                                    <div className="home-whyChooseUs-suncontent-img">
                                        <img src={whychoose} alt="women in mask" />
                                    </div>
                                    <div className="home-whyChooseUs-suncontent-div">
                                        <p>Science is the key to unlocking tomorrow’s possibilities.</p>
                                        <img src={whychoose2} alt="whychoose2" />
                                    </div>
                                </div>
                            </div>

                            <div className="home-whyChooseUs-images">
                                <div className="home-whyChooseUs-images-con">
                                    <div className="home-whyChooseUs-elements" >
                                        <img src={whychoose4} alt="whychoose3" />
                                    </div>
                                    <img src={whychoose3} alt="whychoose3" />
                                    <div className="home-whyChooseUs-elements2" >
                                        <img src={whychoose4} alt="whychoose3" />
                                    </div>
                                    <div className="home-square-box-whychoose"></div>

                                </div>

                                <div className="home-whyChooseUs-button"  onClick={()=>navigate('/aboutus')}>
                                    <button>About Us <ArrowForwardIcon /></button>
                                </div>

                            </div>

                        </div>
                    </div>


                    <div className="home-science-section">
                        <div className="home-science-head">
                            <div className="home-science-head-img">
                                <img src={siccap} alt="capsule" />
                            </div>
                            <div className="home-science-heading">
                                <h1><span>Enhancing Scientific Endeavors,</span><br /> Transforming Lives</h1>
                            </div>
                            <div className="home-square-box1"></div>
                        </div>
                        <div className="home-science-boxsection">
                            <div className="home-science-leftbox">
                                <div className="home-science-leftbox1" onClick={()=>navigate('/ourscience')}>
                                    <div className="home-leftbox1-con">
                                        <h1>Research &<br /> Development</h1>
                                        <img src={RnD} alt="Research & Development" />
                                    </div>
                                    <div className="home-leftbox1-arrw">
                                        <img src={sicarrow} alt="arrow" />
                                    </div>
                                </div>
                                <div className="home-science-leftbox2" onClick={()=>navigate('/ourscience')}>
                                    <div className="home-leftbox2-con">
                                        <h1>Manufacturing </h1>
                                        <img src={siencebox2} alt="Research & Development" />
                                    </div>
                                    <div className="home-leftbox1-arrw">
                                        <img src={sicarrow} alt="arrow" />
                                    </div>
                                </div>
                            </div>
                            <div className="home-science-rightbox" onClick={()=>navigate('/ourscience')}>
                                <div className="home-science-rightbox-top">
                                    <div className="home-science-rightboxhead">
                                        <h1>Small Molecules <br />Peptides <br /> Oligonucleotides</h1>
                                    </div>
                                    <div className="home-leftbox1-arrw">
                                        <img src={sicarrow} alt="arrow" />
                                    </div>
                                </div>
                                <div className="home-science-rightboximg">
                                    <img src={siencebox3} alt="box3" />
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="home-team-con">
                        <div className="home-team-head">
                            <h1>Meet the <span> <i>Minds </i></span>  Behind the Innovation</h1>
                            <p>Our diverse team of scientists, innovators, and experts drives Arde’s Laboratories' mission forward. With a shared commitment to excellence, they bring expertise, creativity, and passion to deliver impactful solutions in healthcare.</p>
                        </div>

                        <div className="home-team">
                            <div className="home-each-team">
                                <img src={team1} alt="team1" />
                                <h4>Lanka Rao Konda</h4>
                                <p>Director Business Operations</p>
                            </div>
                            <div className="home-each-team">
                                <img src={team2} alt="team1" />
                                <h4>Venkateswara Rao Patakota </h4>
                                <p>Director Financial Operations</p>
                            </div>
                            <div className="home-each-team">
                                <img src={team3} alt="team1" />
                                <h4>Srinivasa Bikkumalla</h4>
                                <p>COO & Head Global BD and operations</p>
                            </div>
                        </div>
                        <div className="home-button"  onClick={()=>navigate('/aboutus')}>
                            <button>Our Team <ArrowForwardIcon /></button>
                        </div>

                    </div>

                    <div className="home-service-section">
                        <div className="home-service-head">
                            <h1>Comprehensive <span><i>Services</i></span>  for Every <br />Stage of Innovation</h1>
                        </div>
                        <div className="home-services">
                            <div className="home-services-set1">
                                <div className="home-each-service home-each-service1">
                                    <img src={service1} alt="service" />
                                    <p>Third-Party <br /> Manufacturing</p>
                                </div>
                                <div className="home-each-service-high home-each-service-high1 ">
                                    <img src={service2} alt="service" />
                                    <p>API Development & <br /> Manufacturing</p>
                                </div>
                                <div className="home-each-service">
                                    <img src={service3} alt="service" />
                                    <p>Drug Discovery  <br /> Services</p>
                                </div>
                            </div>

                            <div className="home-services-set1">
                                <div className="home-each-service">
                                    <img src={service4} alt="service" />
                                    <p>Process Development &  <br /> Scale-Up</p>
                                </div>
                                <div className="home-each-service-high">
                                    <img src={service5} alt="service" />
                                    <p>Analytical Development & <br /> Validation</p>
                                </div>
                                <div className="home-each-service">
                                    <img src={service6} alt="service" />
                                    <p>Technology <br /> Transfer</p>
                                </div>
                            </div>
                        </div>
                        <div className="home-contact-button"  onClick={()=>navigate('/services')}>
                            <button>Explore Our Expertise <ArrowForwardIcon /></button>
                        </div>
                    </div>

                    <div className="home-contact-con">
                        <div className="home-contact">
                            <div className="home-contact-cantent">
                                <h2>Questions? Get in Touch</h2>
                                <p>We’re here to help with any questions about your future at Arde’s Laboratories. Connect with us directly or explore our careers page to learn more.</p>
                                <button onClick={()=>navigate('/contactus')}>Get In Touch <ArrowForwardRoundedIcon /></button>
                            </div>
                        </div>
                    </div>


                    <div className="service-ourpartner-container">
                        <h2 className="service-ourpartners-header">our Clients</h2>
                        <Marquee className="service-ourpartner-marquee" autoFill={true} pauseOnHover={true} gradient={true} gradientColor={'#d5f0ff'}>
                            <div className="service-ourpartners-each">
                                <img src={Partner1} alt='partner' />
                            </div>
                            <div className="service-ourpartners-each">
                                <img src={Partner2} alt='partner' />
                            </div>
                            <div className="service-ourpartners-each">
                                <img src={Partner3} alt='partner' />
                            </div>
                            <div className="service-ourpartners-each">
                                <img src={Partner4} alt='partner' />
                            </div>
                        </Marquee>
                    </div>




                </div>
                <Footer />
            </>
        );
    }

    export default Home;